import {ValueObject} from '@s-ui/domain'

import {FilterIdSearchValueObject} from './FilterIdSearchValueObject.js'

export class FilterCityIdSearchValueObject extends ValueObject {
  #cityId

  constructor({cityId}) {
    super()
    this.#cityId = cityId
  }

  static create({cityId}) {
    return new FilterCityIdSearchValueObject({cityId: FilterIdSearchValueObject.create(cityId)})
  }

  static createWithDefaultValue({config, cityId}) {
    const {DEFAULT_CITY_ID_SEARCH} = config.get('searchFilters')

    return new FilterCityIdSearchValueObject({
      cityId: FilterIdSearchValueObject.create({id: cityId ?? DEFAULT_CITY_ID_SEARCH})
    })
  }

  get isEmpty() {
    return this.#cityId.isEmpty
  }

  get value() {
    return this.#cityId.value
  }

  toJSON() {
    return {
      city: this.#cityId.toJSON()
    }
  }
}
